//Dummy json data
export const REST_SERVICE_URL_ROOT = process.env.REACT_APP_API_URL;

//Root Client
export const URL_ROOT = process.env.REACT_APP_URL;
//Persisted key 
export const PERSISTED_STATE_KEY = process.env.REACT_APP_PERSISTED_KEY;
//Client Id
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
//Client Secret
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
//Root
export const ROOT = '/';

//Encryption Key
export const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

//Paypay 
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
export const PAYPAL_CLIENT_SECRET = process.env.REACT_APP_PAYPAL_CLIENT_SECRET;
export const PAYPAL_BASE_URL = process.env.REACT_APP_PAYPAL_BASE_URL;

export const REST_COUNTRIES = "https://restcountries.eu/rest/v2/all";